import { render, staticRenderFns } from "./SrColorPicker.vue?vue&type=template&id=2353b6f8"
import script from "./SrColorPicker.vue?vue&type=script&lang=js"
export * from "./SrColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports